import RecentOrdersModule from './RecentOrders.module';

export default RecentOrdersModule;
